<template>
 <div class='tour'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> --><br />
    <h1 class='daytour'>Family building</h1>

    <div class='tourPicWithTextOver'>
      <p class='text1'> Family Holidays Montenegro </p>
      <p class='text2'> Refresh and strengthen your family ties!  </p>
      <p class='text3' > Carefree vacation in the rhythm that will be loved by a whole family </p>
      <img src='@/assets/familybuilding/family00.jpg' />
    </div>

    <div
      style='
        margin: 0 auto;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 10px 5vw;
      '
    >
      <vue-picture-swipe :items='items'></vue-picture-swipe>
    </div>

    <p class='pasus'>Whether you are a lover of nature, mountain regions and rural areas, or you prefer sun and coastal destinations, Montenegro offers many opportunities of unforgettable vacation and great experience for the whole family.</p>
    <p class='pasus'>You can spend your entire vacation in the beautiful mountain regions, visiting national parks and other attractions in the north of Montenegro, or in comfortable hotels or apartments located in the hinterland of beautiful beaches and go on great excursions from there. Or you can combine these two options!</p>
    <p class='pasus'>If you want a more active holiday, there are numerous opportunities for walks, horse riding, rafting, cycling, zip lining, visiting caves...</p>
    <p class='pasus'>Visit authentic rural areas and lifestyles. Get to know the flora and fauna.</p>
    <p class='pasus'>We will do our best to create tours that will include the most interesting places and attractions in Montenegro to fit your wishes and interests.</p>
    <p class='pasus'>We will choose hotels or other sorts of accommodation that will best satisfy your family needs.</p>
    <p class='pasus'>Montenegro is a great place for vacation, but also a place where your children can experience and learn a lot.</p>
    <p class='pasus'>Montenegro is a very safe destination, so your vacation with kids will be truly relaxing.</p>
    <p class='pasus'>Let's create an unforgettable vacation together!</p>
    <p class='pasus'><p class='pasus'></p>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/familybuilding/01.jpg'),
          thumbnail: require('@/assets/familybuilding/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/02.jpg'),
          thumbnail: require('@/assets/familybuilding/02.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/03.jpg'),
          thumbnail: require('@/assets/familybuilding/03.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/04.jpg'),
          thumbnail: require('@/assets/familybuilding/04.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/05.jpg'),
          thumbnail: require('@/assets/familybuilding/05.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/06.jpg'),
          thumbnail: require('@/assets/familybuilding/06.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/07.jpg'),
          thumbnail: require('@/assets/familybuilding/07.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/08.jpg'),
          thumbnail: require('@/assets/familybuilding/08.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/10.jpg'),
          thumbnail: require('@/assets/familybuilding/10.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/11.jpg'),
          thumbnail: require('@/assets/familybuilding/11.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/12.jpg'),
          thumbnail: require('@/assets/familybuilding/12.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/13.jpg'),
          thumbnail: require('@/assets/familybuilding/13.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/14.jpg'),
          thumbnail: require('@/assets/familybuilding/14.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/15.jpg'),
          thumbnail: require('@/assets/familybuilding/15.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/16.jpg'),
          thumbnail: require('@/assets/familybuilding/16.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/17.jpg'),
          thumbnail: require('@/assets/familybuilding/17.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/20.jpg'),
          thumbnail: require('@/assets/familybuilding/20.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/23.jpg'),
          thumbnail: require('@/assets/familybuilding/23.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/24.jpg'),
          thumbnail: require('@/assets/familybuilding/24.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/25.jpg'),
          thumbnail: require('@/assets/familybuilding/25.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/familybuilding/26.jpg'),
          thumbnail: require('@/assets/familybuilding/26.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPicWithTextOver {
  margin-top: 5vh;
  width: 100%;
  position: relative;
  display: inline-block;
}

.tourPicWithTextOver p {
  width: 80%;
  transform: translate(-50%, -50%);
  background-color: rgba(255, 255, 255, 0); /* Optional: add a semi-transparent background */
  padding: 10px; /* Optional: add padding for better visibility */
  color:rgb(172, 62, 11);
  font-weight: 300;
}
.text1 {
      position: absolute;
      top: 5%;
      left: 50%;
      font-size: 2.4vw;
    }

.text2 {
      position: absolute;
      top: 13%;
      left: 50%;
      font-size: 2vw;
    }

.text3 {
      position: absolute;
      top: 20%;
      left: 50%;
      font-size: 1.7vw;
    }

.tourPicWithTextOver img {
      max-width: 100%;
    }

.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/FamilyBuilding.vue